'use client';

import React from 'react';
import { usePrivy } from '@privy-io/react-auth';

type ConnectProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function ModalConnect({ className }: ConnectProps) {
  const { login, authenticated } = usePrivy();

  return (
    <div className="flex flex-col z-50 w-full">
      <h2 className="my-4 mx-auto">
        You must first connect and sign in with your wallet.
      </h2>
      <div className="flex items-center w-full">
        {!authenticated && (
          <button
            onClick={login}
            className="flex justify-center whitespace-nowrap items-center border border-link hover:border-hover bg-link hover:bg-hover px-4 py-2 rounded-md uppercase text-[12px] text-btntext hover:btntextHover w-full"
          >
            Connect Wallet
          </button>
        )}
      </div>
    </div>
  );
}
